export const COMPONENT_STATE_INIT_INSTANCE = "COMPONENT_STATE_INIT_INSTANCE";
export const COMPONENT_STATE_UPDATE_INSTANCE = "COMPONENT_STATE_UPDATE_INSTANCE";
export const COMPONENT_STATE_CLEAR_INSTANCE = "COMPONENT_STATE_CLEAR_INSTANCE";
export const COMPONENT_STATE_RESET_COMPONENT = "COMPONENT_STATE_RESET_COMPONENT";
